
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Hook to redirect authenticated users away from pages like login/signup
 * that should only be accessible to unauthenticated users
 * @param redirectPath - Path to redirect to when user is authenticated
 * @param shouldRedirect - Optional boolean to control whether redirection should occur (default: true)
 */
export function useRedirectAuthenticated(redirectPath: string = '/', shouldRedirect: boolean = true) {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isAuthenticated && shouldRedirect) {
      navigate(redirectPath, { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate, redirectPath, shouldRedirect]);

  return { isAuthenticated, isLoading };
}
